// 영업활동계획(신규) 라우트 — 새 테이블 전용 화면. 기존 router/mypage/mypage.js 는 건드리지 않는다.
import BsnPlan2List from '@/views/mypage/bsnPlan2/BsnPlan2List'
import BsnPlan2Reg from '@/views/mypage/bsnPlan2/BsnPlan2Reg'
import BsnPlan2Detail from '@/views/mypage/bsnPlan2/BsnPlan2Detail'
import BsnPlan2MemberList from '@/views/mypage/bsnPlan2/BsnPlan2MemberList'
import BsnPlan2MemberDetail from '@/views/mypage/bsnPlan2/BsnPlan2MemberDetail'

export default [
    {
        path: '/bsnplan2/list',
        name: 'bsn-plan2-list',
        component: BsnPlan2List,
        meta: {
            auth: true,
            logging: true,
            pageName: '영업활동계획 목록(신규)'
        }
    },
    {
        path: '/bsnplan2/reg',
        name: 'bsn-plan2-reg',
        component: BsnPlan2Reg,
        meta: {
            auth: true,
            logging: true,
            pageName: '영업활동계획 등록(신규)'
        }
    },
    {
        path: '/bsnplan2/detail',
        name: 'bsn-plan2-detail',
        component: BsnPlan2Detail,
        meta: {
            auth: true,
            logging: true,
            pageName: '영업활동계획 상세(신규)'
        }
    },
    {
        path: '/bsnplan2/memberList',
        name: 'bsn-plan2-member-list',
        component: BsnPlan2MemberList,
        meta: {
            auth: true,
            logging: true,
            pageName: '영업활동계획 목록(지국장, 신규)'
        }
    },
    {
        path: '/bsnplan2/memberDetail',
        name: 'bsn-plan2-member-detail',
        component: BsnPlan2MemberDetail,
        meta: {
            auth: true,
            logging: true,
            pageName: '영업활동계획 상세(지국장, 신규)'
        }
    }
]
